<template>
  <el-card style="margin-bottom: 10px">
    <template v-if="workOrder.status === 2">
      <div style="text-align: center; color: #606266; font-size: 16px">
        已关闭
      </div>
    </template>
    <el-steps
      v-else-if="workOrder.handleResult === 'OTHERS'"
      :active="active()"
      finish-status="success"
      process-status="finish"
    >
      <el-step title="待处理"></el-step>
      <el-step title="处理中"></el-step>
      <el-step title="已处理"></el-step>
      <el-step title="已关闭"></el-step>
    </el-steps>
    <el-steps
      v-else
      :active="active()"
      finish-status="success"
      process-status="finish"
    >
      <el-step title="审批中"></el-step>
      <el-step title="待处理"></el-step>
      <el-step title="处理中"></el-step>
      <el-step title="已处理"></el-step>
      <el-step title="已关闭"></el-step>
    </el-steps>
  </el-card>
</template>

<script>
export default {
  name: "orkOrderStatusInfo",
  props: {
    workOrder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      statusEnum: {
        0: 0,
        4: 1,
        1: 2,
        2: 3,
      },
    };
  },
  methods: {
    active() {
      if (this.workOrder.handleResult === "OTHERS") {
        return this.statusEnum[this.workOrder.status];
      }

      if (this.workOrder.handleResult === "NOT_PASS") {
        return 1;
      }

      if (this.workOrder.handleResult === "UNDER_REVIEW") {
        return 0;
      } else {
        return this.statusEnum[this.workOrder.status] + 1;
      }
    },
  },
};
</script>

<style scoped></style>
